import React, { useContext, useState } from "react";
import BackButton from "../../components/common/BackButton";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";
import { useGlobalSpinnerActionsContext } from "../../components/loader/useloader";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { getClientIp } from "../../helperFunctions/helperFunctions";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import './css/IPOBiding.css';
import IPOCommonBiding from "./IPOCommonBiding";
import IPOShowDetails from "./IPOCommonDetails";
import { TermsAndConditionsCheck } from "./IPOModify";

const IPOCancel = ({
    nextStep,
    prevStep,
    ipoDetails,
    bidingDetail,
    goToPage
}) => {
    console.log(bidingDetail)
    if(ipoDetails.Indetails){
        ipoDetails = ipoDetails.Indetails
    }
    const biddingDetails = ipoDetails?.BidingDetails

    const showAlert = useNotificationActionsContext()
    const setGlobalSpinner = useGlobalSpinnerActionsContext();

    const existingBids = ipoDetails.BidingDetails.bids

    const stepBack = () => {
        // prevStep();
        goToPage(1)
    }
    const [bidDetails, setbidDetails] = useState(bidingDetail);
    const [acceptTermsandconditions, setacceptTermsandconditions] = useState(false)
    const [deleteId,setdeleteId] = useState('');

    const [showUPIerrro, setshowUPIerrro] = useState('');
    const [showInverrro, setshowInverrro] = useState('');
    const [isSubmitting,setSubmitting] = useState(false)


    const updateTerms = (e) =>{
        setacceptTermsandconditions(e.target.checked)
    }
    const [termsError, setTermsError] = useState('');
    const handleSubmit = () => {
        // show modal 
        if(acceptTermsandconditions == true){
            setTermsError('')

            setShowConfirmation(true);

        }else {
            setTermsError('Please accept Terms and Conditions')
        }
       
       
    }

    const viewSummary = () => {
        goToPage(3)
    }
    const goTOCancelorder = () =>{
        goToPage(5)
    }
    const [showConfirmation, setShowConfirmation] = useState(false)
    const closestatus = (that)=>{
        setShowConfirmation(false);
        if(that == 'yes'){
            goTOCancelorder();
        //     console.log(deleteId)
        // let localDate = bidDetails.filter(item => item.id != deleteId);
        // setbidDetails(localDate)
        // setdeleteId('')
        }
    }

    const onAddingItem = (i, index) => (event) => {
        let items = [...bidDetails];
        let item = { ...items[index] };
        item.selectstatus = !item.selectstatus;
        items[index] = item;
        setbidDetails(items);
      }

      const updatesetbidDetailshere = (that) =>{
        setbidDetails(that)
    }


    const highestBid = bidDetails.reduce(function (prev, current) {
        return ((+prev.cart.quantity * +prev.cart.price) > (+current.cart.quantity * +current.cart.price)) ? prev : current
    })
    const totalBiddingAmount =  Number(highestBid.cart.quantity) * Number(highestBid.cart.price)
    const totalShares = bidDetails.reduce(function (total, current) {
        return total + Number(current.cart.quantity) 
    },0) 

    const [upiValue, setupiValue] = useState('')
    const updateUpi = (e) =>{
        setupiValue(e.target.value)
    }
    const contextapi = useContext(Context);

    const cancelTransaction = async () => {
        setGlobalSpinner(true)
        var useData = contextapi.getSession("userData");
        let url = configData.baseURLDev + "/nse/modifytransaction"
        const jsonDataAsperAPIS = []

        for(let i=0;i<bidDetails.length;i++){
            console.log(bidDetails)
            const existingBid = ipoDetails.BidingDetails.bids[i] || bidDetails[i]
            if(existingBid.can_cancel_flag == 'N'){
                continue
            }
            jsonDataAsperAPIS.push({
                "bid_no":(i+1),
                "bid_refno":         existingBid.kfin_refno,
                "bid_flag":          existingBid.bid_flag,
                "action_flag":'C',
                "old_quantity":      existingBid.quantity,
                "old_cutoff_flag":   existingBid.cutoff_flag,
                "old_price":         existingBid.amount,
                "quantity":bidDetails[i].cart.quantity,
                "cutoff_flag":bidDetails[i].cutoffprice == true?"Y":'N',
                "price": bidDetails[i].price
            })
        }

        console.log(postobjt)
        console.log(ipoDetails.BidingDetails.bids)
        console.log(ipoDetails.BidingDetails.bids[0])
    
        var postobjt = {
           
           
            "user_key":useData.user_key,
            "agent_id": "",
            "symbol": ipoDetails.Symbol,
            // "category": selectionTypeCatBrand,
            // "pan": useData.pan,
            // "depository": "N",
            // "folio":createdFolio,
            // "name": useData.name,
            // "upi":upiValue,
            "noof_bids": bidDetails.length,
            "user_ip": await getClientIp(),
    
            "appl_refno": ipoDetails.BidingDetails.appl_refno,
            "appl_no": ipoDetails.BidingDetails.appl_no,
    
            "bid_details":jsonDataAsperAPIS
        };

        contextapi
          .postApiAuthCalling(url, postobjt, false)
          .then((res) => {
            console.log(res);
            console.log(postobjt);
            let ipoDetailsLoc =ipoDetails.Indetails;
            ipoDetailsLoc.APIList = postobjt
            // let summaJson = {
            //     apisReq: postobjt,
            //     innerdetails: ipoDetails
            // }
    
            if (res[0].status_code === "10") {
              var cseData = res.data;
              goToPage(4,ipoDetailsLoc);
              showAlert({ val: true, msg: 'Success!' });   
            } else {
              showAlert({ val: true, msg: `Error: ${res[0].status_desc}` });
            }
          })
          .catch((error) => {
              console.error(error)
            showAlert({ val: true, msg: 'Error occured!' });
            console.log(postobjt);
            
          }).finally(()=>{
              setSubmitting(false)
              setGlobalSpinner(false);
          });
    };

    function cancelIPO(){
        cancelTransaction()
    }

    
    const cancelable = !isSubmitting && existingBids.some(bid => bid.can_cancel_flag == 'Y')

        console.log(cancelable,existingBids)
    return (
        <div>
            <div className="col-lg-12 col-md-12 col-12 addmargin">
                <h5 className='transactionheader'>CANCEL IPO ORDER</h5>
                <p className="transactionheader_desc">The following content shows the details of an IPO</p>

                <BackButton/>
            </div>

            <div className="IPOCard-List">
                <div className="row makerel">
{/* 
                    <div className="graphTopflex">
                        <div className="indivgraph">
                            <CircularProgressbar
                                value="90"
                               
                                text={`/`}
                                className="ProgressBar"
                                styles={buildStyles({
                                    pathTransitionDuration: 1,

                                    pathColor: "#11269229",
                                    trailColor: "#FDFDFE"




                                })}
                            />
                            <div className="graphInnerbox">
                                <p className="labelingrapgsummary">Total Share</p>
                                <p className="valueingraphsummary">18</p>
                            </div>
                        </div>

                        <div className="indivgraph">
                            <CircularProgressbar
                                value="90"
                               
                                text={`/`}
                                className="ProgressBar"
                                styles={buildStyles({
                                    pathTransitionDuration: 1,
                                    pathColor: "#3A57E8",
                                    trailColor: "#FDFDFE"
                                })}
                            />
                            <div className="graphInnerbox">
                                <p className="labelingrapgsummary">Total Investment (₹)</p>
                                <p className="valueingraphsummary">58,384.64</p>
                            </div>
                        </div>



                    </div> */}

                    <div className="makeMargin">


                        {/* <div className="row ">
                            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                                <div className="newFlexItems">
                                    <div className="innerImageDiveView_new cursorPointer" >

                                        {
                                            ipoDetails.ipotime == 'new' &&
                                            <div className="postionbadge">
                                                <div className="badgearrow">New</div>
                                            </div>
                                        }

                                        <img src={lifeinsurancelic} alt="lifeinsu" className="IPOImg" />
                                    </div>


                                    <div className="makeitmiddlealign_new">
                                        <p className="ipoNameValue">{ipoDetails.ipoName}</p>
                                        <p className="ipodateRange">{ipoDetails.ipoDate}</p>
                                    </div>


                                    <div className="makeitmiddlealignmore_new">
                                        <div className={`ipostatus algincenter mobltop ${ipoDetails.status === "Open" ? 'clrgreen' : (ipoDetails.status === "Closed") ? 'clrorange' : (ipoDetails.status === "Upcoming") ? 'lightred' : ''}`}>
                                            {ipoDetails.status}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                                <div className="newFlexItems">
                                    <div className="  algincenter secondpartFlexfirst_details">
                                        <p className="ipoNameValue">Quantity</p>
                                        <p className="ipodateRange">{ipoDetails.quantity}</p>
                                    </div>

                                    <div className=" algincenter  secondpartFlexsecond_details">
                                        <p className="ipoNameValue">Price Range</p>
                                        <p className="ipodateRange">{ipoDetails.priceRange}</p>
                                    </div>

                                    <div className="secondpartFlexthirdIPODeails">

                                        {

                                            <div className=" algincenter">
                                                <button className="ipo-list-placeorder" onClick={() => viewSummary()}>VIEW SUMMARY</button>

                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {!!biddingDetails &&                  
                            <div className="d-flex gap-4 mb-3 ms-3 ms-md-0">
                                <div className="">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        PAN
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.pan}
                                    </p>
                                </div>
                                <div className="">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        DPID
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.dpid}
                                    </p>
                                </div>
                                <div className="me-auto">
                                    <p className="mb-1" style={{fontWeight:'500'}}>
                                        Application no
                                    </p>
                                    <p className="mb-1">
                                        {biddingDetails?.appl_no}
                                    </p>
                                </div>
                            </div>
                        }


                        <IPOShowDetails ipoDetails={ipoDetails} viewSummarFunc={viewSummary}/>
                    </div>

                        {/* <IPOCommonBiding bidDetails={bidDetails} updatesetbidDetails={updatesetbidDetailshere} ipoDetails={ipoDetails} bidingReason="cancel" /> */}

                        <IPOCommonBiding 
                            noWarnings
                            notCheckable
                        bidDetails={bidDetails} 
                        updatesetbidDetails={updatesetbidDetailshere} 
                        ipoDetails={ipoDetails} bidingReason="cancel"/>

                    {/* {

                        bidDetails.map((biddetail, index) => (

                            <div className="bidedetailsDiv" key={index}>
                                <div className="row ">
                                    <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="parentFlex">
                                            <div className="bidOneDiv">
                                              
                                                <Checkbox
                                                label=""
                                                                                                
                                                style={{transform: "scale(0.5)",}}
                                                sx={{
                                                    color: '#343D7E',
                                                    '&.Mui-checked': {
                                                    color: '#343D7E',
                                                    },
                                                }} 
                                                value={biddetail.id}
                                                 checked={biddetail.selectstatus} 
                                                 onChange={onAddingItem(biddetail,index )}
                                                />

                                                <div className="bidBox">
                                                Bid {(index+1)}
                                                </div>
                                            </div>
                                            <div className="bidTwoDiv">
                                                <p className="lotLable">Lot Size:</p>
                                                <p className="lotValue">{biddetail.lotsize}</p>
                                            </div>
                                            <div className="bidThreeDiv">
                                                <input type="checkbox" className="checkbox" />
                                                <p className="lotLable">Cut-off Price</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="parentFlex">
                                            <div className="bidSecondDiv">
                                                <p className="lotLable">Price:</p>
                                                <p className="lotValue">₹ {biddetail.price}</p>
                                            </div>
                                            <div className="bidSecondDiv">
                                                <p className="lotLableorderid">Order ID: {biddetail.orderId}</p>
                                            </div>
                                            <div className="bidSecondDiv juend">
                                                <div className="alighRight ">
                                                    <img src={deleteIcon} alt="deleteIcons" className="deleImg" onClick={() => deleteThis(biddetail.id)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    } */}

                    <div className="row paddingzero">
                        <div className="col-lg-12 col-md-12 margiwithline">
                             <TermsAndConditionsCheck accept={acceptTermsandconditions}
                                onChange={updateTerms} termsError={termsError}
                            />
                        </div>
                        <hr className="hr" />

                       
                        <div className="col-md-12 custompadding  ">
                                <div className=" text-endcustom">
                                    <button type="button" name="button"
                                     className={`clnsorde ${cancelable?'':'opacity-50'}`} onClick={()=>handleSubmit(ipoDetails)}
                                        disabled={!cancelable}
                                    > 
                                        Cancel Order
                                    </button>
                                </div>
                        </div>
                       

                    </div>

                    {/* <div className="row">
                        <div className="col-lg-12 col-md-12 margiwithline">
                            <input type="checkbox" className="acceptTermaandconditions" value={acceptTermsandconditions} onChange={(e) =>updateTersm(e)}/><span className="margiwithline_color">I Accept the <u>Terms & conditions</u></span>
                            <br />
                            {
                                showTerms != '' &&
                                <p className="termsanccond">{showTerms}</p>
                            }
                        </div>
                        <hr className="hr" />
                        <div className="col-lg-12 col-md-12">
                            <div className="textRight"> <button className="clnsorde" onClick={()=> deleteThis()}>CANCEL ORDER</button>

                            </div>

                        </div>

                    </div> */}

                </div>
            </div>
            
           <ConfirmationDialog 
                open={showConfirmation}
                onClose={()=>setShowConfirmation(false)}
                message={`Are you sure you want to cancel this order?`}
                onOptionClick={(decision,i)=>{
                    if(!i){
                        cancelIPO()
                        // setShowConfirmation(false)
                    }
                }}
           />
           
        </div>
    );
}

export default IPOCancel;